import {createActions} from 'client/framework';

export default createActions(null, [
  'ADD_SUPPLEMENT',
  'FETCH_SUPPLEMENT',
  'QUESTIONSET_SUPPLEMENTS_RECEIVED'
]);
